// extracted by mini-css-extract-plugin
module.exports = {"heartIcon":"favorite-button_heartIcon__rCL2q","heartIconWithLabel":"favorite-button_heartIconWithLabel__6Ne89"};